import React, { useEffect, useState } from "react";
import "./addmission-portal.css";
import logo_img from "../img/Logo-Daksh-School-1.png";
import axios from "axios";

const Addmission_Portal = () => {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
console.log(data)
  const logout = () => {
    localStorage.removeItem("accessToken");
  };

  // ================= FETCH API =================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://colleage.vercel.app/api/v1/student/getallpdf"
        );
        setData(res.data.data || []);
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="bg-image-addmission-portal py-5">
      <div className="container">
        <div className="row pb-4">
          <div className="col-12 d-flex justify-content-center">
            <img
              className="rounded-4"
              src={logo_img}
              alt=""
              width={150}
            />
          </div>
        </div>
      </div>

      <div className="container py-5 bg-white border rounded">
        <div className="row">
          <div className="col-12">

            {/* ================= NAV TABS ================= */}
            <ul className="nav nav-pills mb-3 d-flex flex-wrap justify-content-evenly">
              {data.map((item, index) => (
                <li key={item._id} className="nav-item">
                  <button
                    className={`nav-link border mb-2 ${
                      activeTab === index ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(index)}
                  >
                    {item.title.toUpperCase()}
                  </button>
                </li>
              ))}
            </ul>

            {/* ================= TAB CONTENT ================= */}
            {data.length > 0 && (
              <div className="tab-content">

                <div className="tab-pane fade show active">

                  {/* PDF BUTTON */}
                  <div className="text-center py-5">
                    <a
                      href={data[activeTab].Pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="btn btn-success border">
                        Download {data[activeTab].title.toUpperCase()}
                      </button>
                    </a>
                  </div>

                  {/* DESCRIPTION (HTML RENDER) */}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data[activeTab].description,
                    }}
                  />

                </div>

              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Addmission_Portal;